import { sha256 } from 'js-sha256';

export const getHashFromRowVersions = (rowVersions: string[]): string => {
  const stringRepresentation = rowVersions.sort().join('-');
  const hash = sha256.create();
  hash.update(stringRepresentation);

  return hash.hex();
};
